import {
    AfterViewInit,
    Component,
    ElementRef,
    inject,
    OnChanges,
    OnInit,
    SimpleChange,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import _ from 'lodash';
import { NzMessageModule, NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { PermissionService } from 'src/app/core/services/permission.service';
import { ScreenLoggedService } from 'src/app/core/services/screenLogged.service';
import { UserLoggedService } from 'src/app/core/services/userLogged.service';
import { ModalRfidComponent } from 'src/app/private/components/modals/modal-rfid/modal-rfid.component';
import { ConfigurationService } from 'src/app/private/services/configuration.service';
import { AuthService } from 'src/app/public/services/auth.service';
import { ScreenDto } from 'src/app/shared/dto/screen.dto';
import { environment } from 'src/environments/environment';
import packageJson from '../../../../../package.json';
import { AuthMethod } from 'src/app/shared/enums/auth-method.enum';
import { UserDto } from 'src/app/shared/dto/user.dto';
import { UserService } from 'src/app/private/services/user.service';
import { CONFIGURATIONS } from 'src/app/core/constants/storage';
import { LocalStorageService } from 'src/app/core/services/storage.service';

@Component({
    selector: 'app-rfid-form',
    templateUrl: './rfid-form.component.html',
    styleUrls: ['./rfid-form.component.scss'],
    standalone: true,
    imports: [
        ReactiveFormsModule,
        FormsModule,
        NzMessageModule,
    ],
})
export class RfidFormComponent implements OnInit, AfterViewInit, OnChanges {
    loginScreen: ScreenDto | null = null;
    screenToBeLogged: Screen | null = null;
    environment: any;
    version: any = packageJson.version;
    helper: JwtHelperService;

    @ViewChild('rfidInput') rfidInput!: ElementRef;

    rfid: string = '';
    
    private readonly authService = inject(AuthService);
    private readonly userService = inject(UserService);
    private readonly screenLoggedService = inject(ScreenLoggedService);
    private readonly userLoggedService = inject(UserLoggedService);
    private readonly toast = inject(NzMessageService);
    private readonly router = inject(Router);
    private readonly configurationService = inject(ConfigurationService);
    private readonly modalService = inject(NzModalService);
    private readonly permissionService = inject(PermissionService);
    private readonly localStorageService = inject(LocalStorageService);

    constructor() {
        this.helper = new JwtHelperService();
    }

    ngOnInit(): void {
        this.environment = _.cloneDeep(environment);
    }

    ngAfterViewInit() {
        setInterval(() => {
            this.rfidInput.nativeElement.focus();
        }, 250);
    }

    ngOnChanges(changes: SimpleChanges) {
        const loginScreen: SimpleChange = changes['loginScreen'];
        if (
            loginScreen != undefined &&
            loginScreen.previousValue != loginScreen.currentValue
        ) {
            this.screenToBeLogged = _.cloneDeep(loginScreen.currentValue);
        }
    }

    async login(): Promise<void | any> {
        try {
            let authToken = null;

            if (this.loginScreen) {
                authToken = await this.authService.login(AuthMethod.RFID, this.rfid, { screenId: this.loginScreen.id });
            } else {
                authToken = await this.authService.login(AuthMethod.RFID, this.rfid);
            }

            const dataToken = this.helper.decodeToken(authToken.accessToken);

            this.userLoggedService.setToken(
                authToken.accessToken
            );

            const user = await this.userService.getById(dataToken.user.id) as UserDto;
            this.userLoggedService.setUserLogged(
                user
            );

            if(authToken.screen){
                this.screenLoggedService.setScreen(
                    authToken.screen
                );
            }

            const configurations = await this.configurationService.getConfigurations().catch((error) => {
                console.error(error);
                this.toast.error('No se han podido cargar las configuraciones');
            });

            this.localStorageService.setItem(CONFIGURATIONS, configurations);

            this.permissionService.loadPermissions();

            this.router.navigate(['/production-orders']);
        } catch (error: any) {
            this.rfid = '';
            return this.toast.error(error.message);
        }
    }

    onRfidRead() {
        const modal = this.modalService.create({
            nzTitle: `Inicio de sesión con RFID`,
            nzContent: ModalRfidComponent,
            nzStyle: { width: '50%', top: '15%' },
            nzClosable: false,
            nzFooter: null,
            nzData: {
                data: {
                    rfid: this.rfid,
                }
            }
        });

        modal.componentInstance?.emitRfid.subscribe((rfid: string) => {
            this.rfid = rfid;
            this.login();
        });
    }
}
